const {apiGetMerchantBalance, apiGetMerchantAppBalance} = require("../../../../../api/merchant/balance");
const {apiAppList} = require("../../../../../api/merchant/app");
const {apiV2CryptoWalletsList} = require("../../../../../api/merchant/cryptoWallet");


module.exports = async ({assetCode, appId, walletId, backToDashboard}) => {
  const availableBalance = await apiGetMerchantBalance()
      .then((res) => {
        const balance = (res.balance_merchant.balances || []).find((el) => el.asset_code === assetCode);

        console.log(balance);

        if (!balance) {
          backToDashboard();
          return;
        }

        return balance.available;
      });

  const appsListRaw = await apiAppList();
  const appsListIdsWithBalance = await apiAppList({has_balance: true})
      .then((res) => res.map(({id}) => id));

  const appsList = appsListRaw.map((el) => {
    const hasBalance = appsListIdsWithBalance.includes(el.id);
    return {...el, hasBalance: hasBalance, disabled: !hasBalance};
  }).sort((prev, next) => {
    return next.disabled ? -1 : 1;
  });

  const appIdInList = !!appId && !!appsList.find((el) => el.id === appId);

  let walletsList = [];
  let appBalance = '0';
  let walletIdinList = false;

  if (appIdInList) {
    appBalance = await apiGetMerchantAppBalance({app_id: appId}).then((res) => {
      const balances = res.balance_merchant.balances[assetCode] || {};
      return balances.available || '0';
    });

    walletsList = await apiV2CryptoWalletsList({app_id: appId}).then((res) => {
      return res.list
        .filter((el) => el.cc_code === assetCode && el.enabled)
        .map(({id, address, enabled}) => ({id, address, disabled: !enabled}));
    });

    walletIdinList = !!walletId && !!walletsList.find((el) => !el.disabled && el.id === walletId);
  }

  return {
    availableBalance,
    appsList,
    appBalance,
    app_id: appIdInList && appId,
    walletsList,
    crypto_wallet_id: !!walletIdinList
      ? walletId
      : walletsList.length === 1
        ? walletsList[0].id
        : ''
  };
}
